export var PACKAGE_VERSION = '3.0.0 (f33df0fb)';
export var THEME = 'open-source';
export var ALWAYS_VISUAL_REFRESH = false;
